/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
'use strict';


//////////////////
// WEBPACK FOOTER
// ./~/draft-js/lib/RawDraftContentState.js
// module id = 124
// module chunks = 0